import http from '../utils/http';
export default{
    GetRoleList(RoleItemStr='' ,QueryText=' 1=1',RoleNames=''){
        let postData = { apiID: '14F081CE-567B-4912-9063-39097BF5BD64'//AddRoleSet
            , data: {  RoleItemStr : RoleItemStr ,QueryText:QueryText,RoleNames:RoleNames} };
        return http.post(sys.apiUrl, postData)
    },
}


// WEBPACK FOOTER //
// ./src/api/sys.api.js